import React, { useCallback, useMemo } from 'react'

import { LightSelect, Textarea, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, shape, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import { TIER } from '../../constants'

function ReasonSelect({
  selectedReason = null,
  isOtherSelected = false,
  otherText = '',
  onReasonChange,
  onOtherTextChange,
  maxCustomReasonLength,
  locale = 'en',
  tier = TIER.ESSENTIALS,
  isFeeFreeFlow = false,
}) {
  const translate = useCallback(
    (key) => I18n.t(
      `subscription_management.cancel_modal.${key}`,
      { ns: 'rails', lng: locale }
    ),
    [locale]
  )

  const reasonOptions = useMemo(() => [
    { value: 'no_longer_need', label: translate('reasons.no_longer_need') },
    { value: 'short_term_project', label: translate('reasons.short_term_project') },
    { value: 'not_enough_models', label: translate('reasons.not_enough_models') },
    { value: 'not_worth_price', label: translate('reasons.not_worth_price') },
    { value: 'not_used_enough', label: translate('reasons.not_used_enough') },
    { value: 'prefer_individual', label: translate('reasons.prefer_individual') },
    ...(tier === TIER.AI_STUDIO
      ? [{
        value: 'generations_not_good_enough',
        label: translate('reasons.generations_not_good_enough'),
      }]
      : []),
    { value: 'other', label: translate('reasons.other') },
  ], [translate, tier])

  return (
    <>
      <div
        className={classnames(
          'cancel-subscription-modal__reason',
          isFeeFreeFlow && 'cancel-subscription-modal__reason--inline-menu'
        )}
      >
        <label
          className="cgt-text-medium cgt-text-medium--semi-bold"
          htmlFor="cancel-reason"
        >
          {translate(isFeeFreeFlow ? 'fee_free.reason_label' : 'reason_label')}
        </label>
        <LightSelect
          id="cancel-reason"
          name="cancel-reason"
          options={reasonOptions}
          value={selectedReason ? selectedReason.value : ''}
          onChange={onReasonChange}
          placeholder={translate('reason_placeholder')}
          isFullWidth
        />
      </div>
      {isOtherSelected && (
        <div className="cancel-subscription-modal__reason">
          <label
            className="cgt-text-medium cgt-text-medium--semi-bold"
            htmlFor="cancel-other-reason"
          >
            {translate('other_label')}
          </label>
          <Textarea
            id="cancel-other-reason"
            placeholder={translate('other_placeholder')}
            value={otherText}
            onChange={onOtherTextChange}
            maxLength={maxCustomReasonLength}
            rows={3}
            isNotResizable
          />
        </div>
      )}
    </>
  )
}

ReasonSelect.propTypes = {
  selectedReason: shape({
    value: string,
    label: string,
  }),
  isOtherSelected: bool,
  otherText: string,
  onReasonChange: func.isRequired,
  onOtherTextChange: func.isRequired,
  maxCustomReasonLength: number.isRequired,
  locale: string,
  tier: string,
  isFeeFreeFlow: bool,
}

export default ReasonSelect
